var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowUp = function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.726 20.35a.75.75 0 0 1-.744-.648l-.006-.102V6.416L6.233 11.18a.75.75 0 0 1-1.136-.974l.073-.084 6.024-6.05a.753.753 0 0 1 .124-.101l.04-.024a.459.459 0 0 1 .093-.044.552.552 0 0 1 .1-.031.569.569 0 0 1 .1-.017.624.624 0 0 1 .046-.004h.058a.76.76 0 0 1 .044.004l-.073-.004a.754.754 0 0 1 .446.148l.01.006c.025.02.05.042.074.066l6.026 6.05a.75.75 0 0 1-.98 1.132l-.083-.073-4.743-4.76V19.6a.75.75 0 0 1-.75.75Z"
  })));
};
export default SvgArrowUp;